// extracted by mini-css-extract-plugin
export default {"container":"PrivacyPolicy_container__1-5QJ","spinnerWrapper":"PrivacyPolicy_spinnerWrapper__KR01i"};